import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface LabManagementState {
  searchQuery: string
  successCount: number
}

const initialState: LabManagementState = {
  searchQuery: '',
  successCount: 0,
}

const LabManagementSlice = createSlice({
  name: 'labManagement',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload
    },
    clearSearchQuery: (state) => {
      state.searchQuery = ''
    },
    incrementSuccessCount: (state) => {
      state.successCount = (state.successCount || 0) + 1
    },
    resetSuccessCount: (state) => {
      state.successCount = 0
    },
  },
})

// Selectors
export const selectSearchQuery = (state: any) =>
  state?.labManagement?.searchQuery
export const selectSuccessCount = (state: any) =>
  state?.labManagement?.successCount

export const {
  setSearchQuery,
  clearSearchQuery,
  incrementSuccessCount,
  resetSuccessCount,
} = LabManagementSlice.actions

export default LabManagementSlice.reducer
